// معرفی وسایط نقلیه
import React, { useState, useEffect, useCallback } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import { openReport } from '../../components/report';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, BASE, qs, toFa, curYear, Grid, Field, TextIn, DateIn, Lookup, Modal, DeleteDialog, MsgDialog,
  excelCols, smallBtn, groupBox, groupTitle,
} from './carsShared';
import CarsFuel from './CarsFuel';
import CarInsure from './CarInsure';
import CarRepair from './CarRepair';
import CarTransferee from './CarTransferee';
import AmountReceiversFuelOil from './AmountReceiversFuelOil';
import CarAllReports from './CarAllReports';

const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL', 'BTNTRANSFEREE', 'BTNFRONTIMAGE', 'BTNREARIMAGE',
  'BTNAMOUNTRECEIVERSFUEL', 'BTNCARFUEL', 'BTNFUELREQUEST', 'BTNFUELCONFIRM', 'BTNCARFUELALLREPORT',
  'BTNCAROIL', 'BTNOILREQUEST', 'BTNOILCONFIRM', 'BTNCAROILALLREPORT',
  'BTNCARINSURE', 'BTNINSUREREQUEST', 'BTNINSURECONFIRM', 'BTNCARINSUREALLREPORT',
  'BTNCARREPAIR', 'BTNREPAIRREQUEST', 'BTNREPAIRCONFIRM', 'BTNCARREPAIRALLREPORT',
  'BTNCARSREPORT', 'BTNFUELHISTORY', 'BTNOILHISTORY', 'BTNREPAIRHISTORY', 'BTNCARSHISTORYREPORT'];

const FUELS = ['بنزین', 'گازوئیل', 'بنزین/گاز'];
const SITUATIONS = ['فعال', 'غیرفعال', 'مجوز کمیسیون فروش'];
const SHOWS = [
  ['all', 'نمایش: همه خودروها'], ['insure_needs', 'نیاز به تمدید بیمه شخص ثالث تا یکماه آینده'],
  ['not_insured', 'فاقد بیمه شخص ثالث معتبر'], ['body_needs', 'نیاز به تمدید بیمه بدنه تا یکماه آینده'],
  ['not_body', 'فاقد بیمه بدنه معتبر'],
];
const EMPTY = () => ({
  car_name: '', car_system: '', type: '', car_color: '', model: '', fuel_id: 0, situation: 0, capacity: '', cylinder: '',
  axle: '', wheel: '', engine_number: '', chassis_number: '', remark: '', car_tag_no: '', car_tag_serial: '',
  department: { id: 0, title: '' }, car_kind: { id: 0, title: '' },
});

const readSummary = () => { try { return localStorage.getItem('CarChkSummary') === '1'; } catch (e) { return false; } };
const saveSummary = (v) => { try { localStorage.setItem('CarChkSummary', v ? '1' : '0'); } catch (e) { /* بی‌اثر */ } };

function rowToForm(r) {
  return {
    car_name: r['نام'] || '', car_system: r['سیستم'] || '', type: r['تیپ'] || '', car_color: r['رنگ'] || '', model: r['مدل'] || '',
    fuel_id: r.FuelId || 0, situation: r.Situation || 0, capacity: r['ظرفیت'] ?? '', cylinder: r['سیلندر'] ?? '',
    axle: r['محور'] ?? '', wheel: r['چرخ'] ?? '', engine_number: r['شماره موتور'] || '', chassis_number: r['شماره شاسی'] || '',
    remark: r['شرح'] || '', car_tag_no: r['شماره'] || '', car_tag_serial: r['سریال'] || '',
    department: { id: r.DepartmentId || 0, title: r['مالک'] || '' }, car_kind: { id: r.CarKindsId || 0, title: r['نوع مالکیت'] || '' },
  };
}

function CarForm({ form, setF }) {
  return (
    <>
      <div style={ui.row}>
        <Field label="نوع"><TextIn value={form.car_name} onChange={v => setF('car_name', v)} /></Field>
        <Field label="سیستم"><TextIn value={form.car_system} onChange={v => setF('car_system', v)} /></Field>
        <Field label="تیپ"><TextIn value={form.type} onChange={v => setF('type', v)} /></Field>
        <Field label="رنگ"><TextIn value={form.car_color} onChange={v => setF('car_color', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="مدل"><TextIn num value={form.model} onChange={v => setF('model', v)} /></Field>
        <Field label="نوع مالکیت"><Lookup path="/lookup/carkind/" value={form.car_kind} onChange={v => setF('car_kind', v)} /></Field>
        <Field label="سوخت">
          <select value={form.fuel_id} onChange={e => setF('fuel_id', Number(e.target.value))} style={ui.input}>
            {FUELS.map((f, i) => <option key={i} value={i}>{f}</option>)}
          </select>
        </Field>
        <Field label="وضعیت">
          <select value={form.situation} onChange={e => setF('situation', Number(e.target.value))} style={ui.input}>
            {SITUATIONS.map((f, i) => <option key={i} value={i}>{f}</option>)}
          </select>
        </Field>
      </div>
      <div style={ui.row}>
        <Field label="ظرفیت"><TextIn num value={form.capacity} onChange={v => setF('capacity', v)} /></Field>
        <Field label="سیلندر"><TextIn num value={form.cylinder} onChange={v => setF('cylinder', v)} /></Field>
        <Field label="محور"><TextIn num value={form.axle} onChange={v => setF('axle', v)} /></Field>
        <Field label="تعداد چرخ"><TextIn num value={form.wheel} onChange={v => setF('wheel', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="شماره موتور"><TextIn num value={form.engine_number} onChange={v => setF('engine_number', v)} /></Field>
        <Field label="شماره شاسی"><TextIn num value={form.chassis_number} onChange={v => setF('chassis_number', v)} /></Field>
        <Field label="شماره"><TextIn value={form.car_tag_no} onChange={v => setF('car_tag_no', v)} /></Field>
        <Field label="سریال"><TextIn value={form.car_tag_serial} onChange={v => setF('car_tag_serial', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="مالک"><Lookup path="/lookup/department/" value={form.department} onChange={v => setF('department', v)} /></Field>
        <Field label="توضیحات" flex={2}><TextIn value={form.remark} onChange={v => setF('remark', v)} /></Field>
      </div>
    </>
  );
}

function ImageDialog({ car, side, onClose }) {
  const [src, setSrc] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const url = `${BASE}/${car.CarId}/image/${side}/`;
  const load = useCallback(async () => {
    setMsg('');
    try {
      const r = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem('access')}` } });
      if (!r.ok) { setSrc(''); setMsg('تصویری ثبت نشده است'); return; }
      const b = await r.blob();
      setSrc(URL.createObjectURL(b));
    } catch (e) { setMsg('ارتباط با سرور برقرار نشد'); }
  }, [url]);
  useEffect(() => { load(); }, [load]);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await fetch(url, { method: 'POST', body: fd, headers: { Authorization: `Bearer ${localStorage.getItem('access')}` } });
      const j = await r.json().catch(() => ({ ok: false, msg: 'خطا در ارسال تصویر' }));
      if (!j.ok) setMsg(j.msg); else load();
    } catch (e) { setMsg('ارتباط با سرور برقرار نشد'); }
    setBusy(false);
  };
  return (
    <Modal title={side === 'front' ? 'تصویر روی کارت خودرو' : 'تصویر پشت کارت خودرو'} onClose={onClose} width="720px"
      footer={<>
        <label style={{ ...ui.btnSave, display: 'inline-block' }}>{busy ? '⏳ ...' : 'انتخاب تصویر'}
          <input type="file" accept="image/*" style={{ display: 'none' }} onChange={e => upload(e.target.files[0])} />
        </label>
        <button onClick={onClose} style={ui.btnCancel}>بستن</button>
      </>}>
      {msg && <div style={ui.errBox}>{msg}</div>}
      {src && <img src={src} alt="کارت خودرو" style={{ maxWidth: '100%', borderRadius: '8px' }} />}
    </Modal>
  );
}

function HistoryDialog({ kind, onClose, onRun }) {
  const [frm, setFrm] = useState('');
  const [to, setTo] = useState('');
  return (
    <Modal title="تاریخ فاکتور" onClose={onClose} width="480px"
      footer={<><button onClick={onClose} style={ui.btnCancel}>انصراف</button>
        <button onClick={() => onRun(kind, frm, to)} style={ui.btnSave}>گزارش</button></>}>
      <div style={ui.row}>
        <Field label="از"><DateIn value={frm} onChange={setFrm} /></Field>
        <Field label="تا"><DateIn value={to} onChange={setTo} /></Field>
      </div>
      <div style={{ fontSize: '11px', color: '#777' }}>در صورت خالی بودن، از اولین تا آخرین تاریخ ثبت‌شده گزارش گرفته می‌شود.</div>
    </Modal>
  );
}

export default function Cars({ user, onBack }) {
  const fb = useFormButtons('FRMCARS', BUTTONS);
  const [summary, setSummary] = useState(readSummary());
  const [year, setYear] = useState(curYear());
  const [search, setSearch] = useState('');
  const [show, setShow] = useState('all');
  const [kinds, setKinds] = useState([]);
  const [kindList, setKindList] = useState(null);
  const [cols, setCols] = useState([]);
  const [sel, setSel] = useState(null);
  const [child, setChild] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY());
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [dup, setDup] = useState(null);
  const [sub, setSub] = useState(null);
  const [saving, setSaving] = useState(false);

  const L = usePagedList((page, o) => API(`/?${qs({ page, summary: o.summary ? 1 : 0, year: o.year, search: o.search, show: o.show, kinds: (o.kinds || []).join(',') })}`)
    .then(j => { if (j.ok && page === 1) setCols(j.columns || []); return j; }));

  const reload = (over = {}) => L.reload({ summary, year, search, show, kinds, ...over });
  useEffect(() => { if (fb.open) reload(); }, [fb.open]);

  useEffect(() => {
    setChild(null);
    if (!sel || summary) return;
    API(`/${sel.CarId}/children/?year=${year}`).then(j => { if (j.ok) setChild(j); });
  }, [sel, summary, year]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const payload = (force) => ({
    ...form, department_id: form.department.id, car_kinds_id: form.car_kind.id, force: force ? 1 : 0,
  });

  const save = async (force = false) => {
    setSaving(true); setErr('');
    const j = modal === 'new'
      ? await API('/create/', { method: 'POST', body: JSON.stringify(payload(force)) })
      : await API(`/${sel.CarId}/update/`, { method: 'PUT', body: JSON.stringify(payload(force)) });
    setSaving(false);
    if (j.confirm) { setDup(j.lines); return; }
    if (!j.ok) { setErr(j.msg); return; }
    setModal(null); reload();
  };

  const doDelete = async () => {
    setModal(null);
    const j = await API(`/${sel.CarId}/delete/`, { method: 'DELETE' });
    if (!j.ok) setMsg(j.msg); else { setSel(null); reload(); }
  };

  const report = async (key, params = {}) => {
    try { await openReport(key, params); } catch (e) { setMsg(e.message); }
  };

  const runHistory = (kind, frm, to) => {
    setModal(null);
    if (kind === 'repair') {
      setModal({ ask: 'pieces', frm, to });
      return;
    }
    report('tadarokat.cars_fuel_history', { is_fuel: kind === 'oil' ? 0 : 1, from: frm, to });
  };

  const confirmKind = (key) => setModal({ ask: 'confirm', key });

  const openKinds = async () => {
    const j = await API('/kinds-filter/');
    if (j.ok) setKindList(j.data.map(k => ({ ...k, on: kinds.length === 0 || kinds.includes(k.id) })));
  };
  const applyKinds = () => {
    const on = kindList.filter(k => k.on).map(k => k.id);
    const v = on.length === kindList.length ? [] : (on.length ? on : [0]);
    setKinds(v); setKindList(null); reload({ kinds: v });
  };

  const carTitle = sel ? `${sel['سیستم'] || ''}  ${sel['نام'] || ''} شماره پلاک ${sel['شماره'] || ''}` : '';

  if (sub) {
    const back = () => { setSub(null); reload(); };
    if (sub === 'fuel' || sub === 'oil') return <CarsFuel user={user} onBack={back} carId={sel.CarId} isFuel={sub === 'fuel' ? 1 : 0} carTitle={carTitle} year={year} />;
    if (sub === 'insure') return <CarInsure user={user} onBack={back} carId={sel.CarId} carTitle={carTitle} year={year} />;
    if (sub === 'repair') return <CarRepair user={user} onBack={back} carId={sel.CarId} carTitle={carTitle} year={year} />;
    if (sub === 'transferee') return <CarTransferee user={user} onBack={back} carId={sel.CarId} carTitle={carTitle} />;
    if (sub === 'receivers') return <AmountReceiversFuelOil user={user} onBack={back} />;
    if (sub.startsWith('all-')) {
      const k = sub.slice(4);
      return <CarAllReports user={user} onBack={back} kind={k === 'oil' ? 'fuel' : k} isFuel={k === 'oil' ? 0 : 1} year={year} />;
    }
  }

  const has = !!sel && fb.open;
  const btn = (code, label, onClick, needSel = true, bg) => fb.can(code) && (
    <button key={code} onClick={onClick} disabled={needSel && !sel} style={{ ...smallBtn(bg), opacity: needSel && !sel ? 0.4 : 1 }}>{label}</button>
  );

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={() => { setForm(EMPTY()); setErr(''); setModal('new'); }} style={ui.btnNew}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button disabled={!has} onClick={() => { setForm(rowToForm(sel)); setErr(''); setModal('edit'); }} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4 }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button disabled={!has} onClick={() => setModal('delete')} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4 }}>✕ حذف</button>}
        {btn('BTNTRANSFEREE', 'ثبت تحویل گیرندگان', () => setSub('transferee'))}
        {btn('BTNFRONTIMAGE', 'اسکن روی کارت', () => setModal({ img: 'front' }))}
        {btn('BTNREARIMAGE', 'اسکن پشت کارت', () => setModal({ img: 'rear' }))}
        {btn('BTNAMOUNTRECEIVERSFUEL', 'سقف سوخت/روغن فروشندگان', () => setSub('receivers'), false)}
      </div>
      <label style={{ fontSize: '12px', alignSelf: 'center' }}>
        <input type="checkbox" checked={summary} onChange={e => { setSummary(e.target.checked); saveSummary(e.target.checked); setSel(null); reload({ summary: e.target.checked }); }} /> خلاصه اطلاعات
      </label>
      {!summary && <Field label="سال مالی" width="80px"><input value={year} onChange={e => setYear(Number(e.target.value) || '')} onKeyDown={e => e.key === 'Enter' && reload()} style={ui.yearInput} /></Field>}
      {!summary && (
        <select value={show} onChange={e => { setShow(e.target.value); reload({ show: e.target.value }); }} style={{ ...ui.searchInput, maxWidth: '280px' }}>
          {SHOWS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      )}
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && reload()} placeholder="جستجو" style={{ ...ui.searchInput, minWidth: '160px' }} />
      <button onClick={openKinds} style={smallBtn('#6a1b9a')}>نوع مالکیت{kinds.length ? ' ✓' : ''}</button>
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="خودرو" />
      <ExcelButton title="معرفی وسایط نقلیه" columns={excelCols(cols, L.data)} rows={L.data} />
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', width: '100%' }}>
        <div style={groupBox}><span style={groupTitle}>سوخت</span><div style={{ display: 'flex', gap: '4px' }}>
          {btn('BTNCARFUEL', 'ثبت برگه', () => setSub('fuel'))}
          {btn('BTNFUELREQUEST', 'برگه درخواست', () => report('tadarokat.cars_pending_fuel_request'), false)}
          {btn('BTNFUELCONFIRM', 'تاییدیه', () => confirmKind('tadarokat.cars_pending_fuel_confirm'), false)}
          {btn('BTNCARFUELALLREPORT', 'گزارش کلی', () => setSub('all-fuel'), false)}
        </div></div>
        <div style={groupBox}><span style={groupTitle}>روغن</span><div style={{ display: 'flex', gap: '4px' }}>
          {btn('BTNCAROIL', 'ثبت برگه', () => setSub('oil'))}
          {btn('BTNOILREQUEST', 'برگه درخواست', () => report('tadarokat.cars_pending_oil_request'), false)}
          {btn('BTNOILCONFIRM', 'تاییدیه', () => confirmKind('tadarokat.cars_pending_oil_confirm'), false)}
          {btn('BTNCAROILALLREPORT', 'گزارش کلی', () => setSub('all-oil'), false)}
        </div></div>
        <div style={groupBox}><span style={groupTitle}>بیمه نامه</span><div style={{ display: 'flex', gap: '4px' }}>
          {btn('BTNCARINSURE', 'ثبت بیمه نامه', () => setSub('insure'))}
          {btn('BTNINSUREREQUEST', 'برگه درخواست', () => report('tadarokat.cars_pending_insure_request'), false)}
          {btn('BTNINSURECONFIRM', 'تاییدیه', () => confirmKind('tadarokat.cars_pending_insure_confirm'), false)}
          {btn('BTNCARINSUREALLREPORT', 'گزارش کلی', () => setSub('all-insure'), false)}
        </div></div>
        <div style={groupBox}><span style={groupTitle}>تعمیرات</span><div style={{ display: 'flex', gap: '4px' }}>
          {btn('BTNCARREPAIR', 'ثبت تعمیرات', () => setSub('repair'))}
          {btn('BTNREPAIRREQUEST', 'برگه درخواست', () => report('tadarokat.cars_pending_repair_request'), false)}
          {btn('BTNREPAIRCONFIRM', 'تاییدیه', () => confirmKind('tadarokat.cars_pending_repair_confirm'), false)}
          {btn('BTNCARREPAIRALLREPORT', 'گزارش کلی', () => setSub('all-repair'), false)}
        </div></div>
        <div style={groupBox}><span style={groupTitle}>گزارش خودروها</span><div style={{ display: 'flex', gap: '4px' }}>
          {btn('BTNCARSREPORT', 'فهرست', () => report('tadarokat.cars_list'), false)}
          {fb.can('BTNCARSHISTORYREPORT') && btn('BTNFUELHISTORY', 'سابقه سوخت', () => setModal({ hist: 'fuel' }), false)}
          {fb.can('BTNCARSHISTORYREPORT') && btn('BTNOILHISTORY', 'سابقه روغن', () => setModal({ hist: 'oil' }), false)}
          {fb.can('BTNCARSHISTORYREPORT') && btn('BTNREPAIRHISTORY', 'سابقه تعمیرات', () => setModal({ hist: 'repair' }), false)}
        </div></div>
      </div>
    </>
  ) : null;

  const grid = (
    <Grid columns={cols} rows={L.data} rowKey="CarId" selectedKey={sel?.CarId} onSelect={setSel}
      rowBg={r => (r.need_renew ? '#ffcdd2' : null)} empty={fb.loaded && !fb.open ? '' : 'خودرویی یافت نشد'} />
  );

  return (
    <>
      <ListPage user={user} onBack={onBack} title="معرفی وسایط نقلیه" subtitle="تدارکات — سامانه ارجان"
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading} unit="خودرو">
        {!summary && child ? (
          <div style={ui.splitWrap}>
            <div style={ui.topPane}>{grid}</div>
            <div style={{ ...ui.bottomPane, display: 'flex', gap: '8px' }}>
              <div style={{ flex: 1, overflow: 'auto' }}>
                <Grid columns={child.transferee_columns} rows={child.transferee} rowKey="CarTransfereeId" empty="تحویل گیرنده مشخص نشده است" />
              </div>
              {child.mission.length > 0 && (
                <div style={{ flex: 2, overflow: 'auto' }}>
                  <Grid columns={child.mission_columns} rows={child.mission} rowKey="CarMissionId" />
                </div>
              )}
            </div>
          </div>
        ) : grid}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? '＋ وسیله نقلیه جدید' : '✎ ویرایش وسیله نقلیه'} onClose={() => setModal(null)}
          footer={<>
            <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>
            {fb.can('BTNOK') && fb.can(modal === 'new' ? 'BTNNEW' : 'BTNEDIT') &&
              <button onClick={() => save(false)} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : 'ثبت'}</button>}
          </>}>
          {err && <div style={ui.errBox}>⚠️ {err}</div>}
          <CarForm form={form} setF={F} />
        </Modal>
      )}
      {dup && (
        <WarningDialog title="انتخاب کنید" lines={dup} confirmLabel="بلی" cancelLabel="خیر"
          onConfirm={() => { setDup(null); save(true); }} onCancel={() => setDup(null)} />
      )}
      {modal === 'delete' && <DeleteDialog onConfirm={doDelete} onCancel={() => setModal(null)} />}
      {modal && modal.img && <ImageDialog car={sel} side={modal.img} onClose={() => { setModal(null); reload(); }} />}
      {modal && modal.hist && <HistoryDialog kind={modal.hist} onClose={() => setModal(null)} onRun={runHistory} />}
      {modal && modal.ask === 'pieces' && (
        <WarningDialog title="انتخاب کنید" lines={['لیست قطعات نشان داده شود']} confirmLabel="بلی" cancelLabel="خیر"
          onConfirm={() => { const m = modal; setModal(null); report('tadarokat.cars_repair_history', { from: m.frm, to: m.to, pieces: 1 }); }}
          onCancel={() => { const m = modal; setModal(null); report('tadarokat.cars_repair_history', { from: m.frm, to: m.to, pieces: 0 }); }} />
      )}
      {modal && modal.ask === 'confirm' && (
        <WarningDialog title="انتخاب کنید" lines={[]} confirmLabel="تاییدیه" cancelLabel="صورتجلسه مصرف"
          onConfirm={() => { const k = modal.key; setModal(null); report(k, { is_confirm: 1 }); }}
          onCancel={() => { const k = modal.key; setModal(null); report(k, { is_confirm: 0 }); }} />
      )}
      {kindList && (
        <Modal title="نوع مالکیت" onClose={() => setKindList(null)} width="420px"
          footer={<>
            <button onClick={() => setKindList(l => l.map(k => ({ ...k, on: true })))} style={ui.btnCancel}>همه</button>
            <button onClick={() => setKindList(l => l.map(k => ({ ...k, on: false })))} style={ui.btnCancel}>هیچ</button>
            <button onClick={applyKinds} style={ui.btnSave}>اعمال</button>
          </>}>
          {kindList.map(k => (
            <label key={k.id} style={{ display: 'block', padding: '4px 0', fontSize: '13px' }}>
              <input type="checkbox" checked={k.on} onChange={() => setKindList(l => l.map(x => (x.id === k.id ? { ...x, on: !x.on } : x)))} /> {toFa(k.title)}
            </label>
          ))}
        </Modal>
      )}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
